import styled, { css } from 'styled-components/macro';
import { Image, ImageStyled } from '@yme/atoms/image';
import { MiniButtonContent } from '@yme/atoms/mini-button';
import { Link } from '@yme/components/Link';
import { colorBlackTransparent50, colorCoreBlack300, colorCoreWhite1000 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { ADAPTIVE } from '@yme/tokens/screen';
import { RegularTextLevel2, RegularTextLevel3, RegularTextLevel4 } from '@yme/tokens/typography';
import { ellipsisEndingLine, getTextStyles } from '@yme/utils/styles';
export const ImageWrapperStyled = styled(Image) `
  min-height: 160px;

  ${ImageStyled} {
    max-height: ${({ heightValue }) => heightValue};
    aspect-ratio: ${({ aspectRatio }) => aspectRatio};
    object-position: center;

    ${({ isContainFit, isImageBackgroundHidden }) => isContainFit
    ? css `
            object-fit: contain;
            background-color: ${isImageBackgroundHidden ? 'transparent' : colorCoreWhite1000};
          `
    : css `
            object-fit: cover;
            background-color: ${isImageBackgroundHidden ? 'transparent' : colorBlackTransparent50};
          `}
  }

  width: 100%;
  margin-bottom: 16px;

  ${({ isLink }) => isLink && `cursor: pointer`};
`;
export const ContentStyled = styled(RegularTextLevel3) `
  display: -webkit-box;
  -webkit-line-clamp: ${({ countLineVisible = 4 }) => countLineVisible};
  -webkit-box-orient: vertical;
  overflow: hidden;

  p {
    margin: 0;
  }

  ${({ isSearchPage }) => isSearchPage &&
    css `
      ${ADAPTIVE.maxWidth.mobile} {
        ${getTextStyles(null, null, 14, 20)}
      }
    `}
`;
export const TitleStyled = styled(RegularTextLevel2) `
  text-decoration: none;

  ${({ isLink }) => !isLink && `cursor: default`};
  ${({ isFullHeaderVisible }) => !isFullHeaderVisible && `${ellipsisEndingLine}`};

  ${({ isSearchPage }) => isSearchPage &&
    css `
      ${ADAPTIVE.maxWidth.mobile} {
        ${getTextStyles(null, null, 16, 24)}
      }
    `}
`;
export const LinkStyled = styled(Link) `
  text-decoration: none;

  ${MiniButtonContent} {
    ${getTextStyles(null, null, 16, 24)}
  }
`;
export const CaptionStyled = styled(RegularTextLevel4) `
  display: block;

  cursor: pointer;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${colorCoreBlack300};

  ${({ isSearchPage }) => isSearchPage &&
    css `
      ${ADAPTIVE.maxWidth.mobile} {
        ${getTextStyles(null, null, 12, 16)}
      }
    `}
`;
export const MiddleDot = styled.div `
  &::after {
    content: ' ';
    width: 4px;
    height: 4px;
    border-radius: 2px;
    background: ${colorCoreBlack300};
  }

  position: relative;
  display: inline-flex;
  margin: 0 12px;
  top: -2px;
`;
export const EventPanelStyled = styled(FlexWrapper) `
  padding: 12px;
  position: absolute;
  top: 0;
`;
export const ImageBlockWrapperStyled = styled(FlexWrapper) `
  position: relative;
`;
export const CardForEventsStyled = styled.div `
  ${({ isRightToLeft }) => isRightToLeft &&
    `
    direction: rtl;
  `}
  margin-bottom: ${({ marginBottom }) => marginBottom && `${marginBottom}`};
`;
